import React from 'react';
import { useLanguageStore, Language } from '../store/languageStore';

interface Step {
  number: number;
  label: Record<Language, string>;
}

interface StepIndicatorProps {
  currentStep: number;
  steps: Step[];
}

const StepIndicator: React.FC<StepIndicatorProps> = ({ currentStep, steps }) => {
  const { selectedLanguage } = useLanguageStore();

  return (
    <div className="flex items-center justify-center gap-1 sm:gap-8 text-[10px] sm:text-sm animate-fade-in px-1 max-w-full">
      {steps.map((step, index) => (
        <React.Fragment key={step.number}>
          <div className={`step relative ${currentStep === step.number ? 'active' : 'opacity-70'} flex-shrink-0 transition-all duration-300`}>
            <div className={`w-6 h-6 rounded-full flex items-center justify-center text-sm font-medium mb-2
              ${currentStep === step.number 
                ? 'bg-blue-600 dark:bg-blue-500 text-white ring-4 ring-blue-100 dark:ring-blue-900/30 transform scale-110' 
                : currentStep > step.number
                ? 'bg-green-500 dark:bg-green-400 text-white'
                : 'bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400'}`}>
              {currentStep > step.number ? '✓' : step.number}
            </div>
            <span className={`whitespace-nowrap px-0.5 sm:px-1 text-center transition-colors duration-300
              ${currentStep === step.number 
                ? 'text-blue-600 dark:text-blue-400 font-medium' 
                : 'text-gray-900 dark:text-gray-100'}`}>
              {(step.label[selectedLanguage] || step.label['EN']).split(' ').map((word, i) => (
                <React.Fragment key={i}>
                  {word}
                  {i < step.label[selectedLanguage].split(' ').length - 1 && <br />}
                </React.Fragment>
              ))}
            </span>
          </div>
          {index < steps.length - 1 && (
            <div className="relative h-px w-8 sm:w-16 flex-shrink-0 mt-4">
              <div className="absolute inset-0 bg-gray-200 dark:bg-gray-700" />
              <div 
                className={`absolute inset-0 bg-blue-600 dark:bg-blue-500 transition-all duration-500 ease-in-out`}
                style={{ 
                  width: currentStep > step.number ? '100%' : 
                         currentStep === step.number ? '50%' : '0%'
                }}
              />
            </div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default StepIndicator;